module.exports = "<div class=\"<%= avatar %>\"\r\n     ng-class=\"{ '<%= inactive %>': !$ctrl.contact.active, '<%= active %>': $ctrl.contact.active }\">\r\n    <span ng-if=\"$ctrl.initials\">\r\n            {{$ctrl.initials}}\r\n    </span>\r\n    <span ng-if=\"!$ctrl.initials\">\r\n        <i class=\"fa fa-user\"></i>\r\n    </span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/gateway/contacts/common/components/ContactAvatar/ContactAvatar.html
// module id = 686
// module chunks = 0